module.exports = __webpack_public_path__ + "static/img/10.3c39c9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/sp/10.png
// module id = FXjh
// module chunks = 0